import { render } from "./EventList.vue?vue&type=template&id=43d89c61&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=43d89c61&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/.pnpm/vue-loader@16.8.1_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d89c61"]])

export default __exports__